import React from "react";
import {CustomRule, PatternRule, RequiredRule, StringLengthRule, Validator} from "devextreme-react/validator";

import {LLInput} from "../../../elements";
import {trans} from "../../../../common/utils";

const SignUpPartOne = ({commonInputProps, form, setForm, errors, setErrors}) => {
    return <div className="signup__part-one">
        <LLInput
            {...commonInputProps}
            label={trans('Username')}
            id="sign-up__username"
            name="sign-up__username"
            minLength={3}
            maxLength={32}
            value={form.username}
            onValueChanged={(e) => {
                setForm((v) => ({
                    ...v,
                    username: e.value,
                }));
                setErrors((v) => ({
                    ...v,
                    username: '',
                }));
            }}
        >
            <Validator>
                <PatternRule
                    message={trans(
                        'You can only use English letters and numbers in your username.'
                    )}
                    pattern={'^[a-zA-Z0-9]+$'}
                />
                <RequiredRule message={trans('USERNAME_EMPTY')}/>
                <StringLengthRule
                    message={trans(
                        'A username can be minimum 3 and maximum 32 characters long.'
                    )}
                    min={3}
                    max={32}
                />
                <CustomRule
                    message={trans(errors.username)}
                    validationCallback={() => !errors.username}
                />
            </Validator>
        </LLInput>
        <LLInput
            {...commonInputProps}
            label={trans('Phone')}
            value={form.phone}
            minLength={10}
            maxLength={10}
            id="sign-up__phone"
            name="sign-up__phone"
            onValueChanged={(e) => {
                setForm((v) => ({
                    ...v,
                    phone: e.value,
                }));
                setErrors((v) => ({
                    ...v,
                    phone: '',
                }));
            }}
        >
            <Validator>
                <RequiredRule message={trans('PHONE_EMPTY')}/>
                <PatternRule
                    message={trans(
                        'Phone number must contain digits only.'
                    )}
                    pattern={'^[0-9]+$'}
                />
                <CustomRule
                    message={trans(
                        'Your phone number should be started from "5"'
                    )}
                    validationCallback={(e) => e.value[0] === '5'}
                />
                <StringLengthRule
                    message={trans(
                        'The phone number must be entered as 10 digits, without the leading 0.'
                    )}
                    min={10}
                    max={10}
                />
                <CustomRule
                    message={trans(errors.phone)}
                    validationCallback={() => !errors.phone}
                />
            </Validator>
        </LLInput>
    </div>
};

export default SignUpPartOne;

